import { MediaFormat } from '@databases/types/database';
import React, { memo, type ReactNode } from 'react';
import {
  type AttachmentReadContent,
  type AttachmentItemContent
} from './attachment-read-content.ts';
import styles from './attachment-value-view.module.css';

export const AttachmentPlaceholder = memo(function AttachmentPlaceholder({
  thumbnail
}: {
  readonly thumbnail: boolean;
}) {
  return <div className={thumbnail ? styles.thumbnailPlaceholder : styles.placeholder} />;
});

/**
 * Stateless V1 geometry; the application supplies media clients and interaction ownership.
 */
export const AttachmentMediaFrame = memo(function AttachmentMediaFrame({
  thumbnail,
  disableOverlay,
  children
}: {
  readonly thumbnail: boolean;
  readonly disableOverlay: boolean;
  readonly children: ReactNode;
}) {
  return (
    <div className={styles.card}>
      <div
        className={
          thumbnail ? styles.thumbnail : disableOverlay ? styles.media : styles.document
        }
      >
        {children}
      </div>
    </div>
  );
});

export const AttachmentValueView = memo(function AttachmentValueView({
  content,
  renderMedia
}: {
  readonly content: AttachmentReadContent;
  readonly renderMedia?: (item: AttachmentItemContent) => ReactNode;
}) {
  if (!content.items.length) {
    return <div className={styles.empty} />;
  }

  const thumbnail = content.mediaFormat === MediaFormat.THUMBNAIL;

  return (
    <ul className={thumbnail ? styles.thumbnails : styles.value}>
      {content.items.map((item) => (
        <li key={item.key} className={thumbnail ? styles.thumbnailItem : styles.item}>
          {item.presentation && renderMedia ? (
            renderMedia(item)
          ) : (
            <AttachmentPlaceholder thumbnail={thumbnail} />
          )}
        </li>
      ))}
    </ul>
  );
});
